<template>
  <div class="content-box">
    <Title />
    <Textlist />
  </div>
</template>

<script>
export default {
  name: "reportCar",
  data() {
    return {
      params: {
        json: 0,
        filter: ["研报", "分析", "（PPT）", "（全文）"],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", "报告 车");
    this.$store.dispatch("getText");
  },
};
</script>
<style scoped>
</style>